import React, { useState } from 'react'
import { useFormik } from 'formik';
import * as yup from "yup";
import settingStyle from '../container/studentDashboard/settings.module.css'
import { useDispatch } from 'react-redux';
import { updatePassword } from '../container/redux/settingSlice';
import { unwrapResult } from '@reduxjs/toolkit';
import { CircularProgress } from '@mui/material';


const ChangePassword = () => {
    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(false);
    const schema = yup.object().shape({
        currentPassword: yup.string().required("Current Password is required"),
        newPassword: yup.string().required("New Password is required"),
        confirmPassword: yup.string().required("Confirm Password is required"),
    })

    const {
        errors,
        values,
        handleChange,
        touched,
        handleBlur,
        handleSubmit,
    } = useFormik({

        initialValues: {
            currentPassword: "",
            newPassword: '',
            confirmPassword: ''
        },
        validationSchema: schema,
        onSubmit: async (values) => {
            if (!isLoading) {
                try {
                    setIsLoading(true)
                    const res = await dispatch(updatePassword(values))
                    await unwrapResult(res);
                } catch (err) {
                    console.log(err)
                } finally {
                    setTimeout(() => {
                        setIsLoading(false)
                    }, 200);
                }
            }
        }
    })
    return (
        <div>
            <h6 className={settingStyle.headingh6}>
                Password
            </h6>
            <div className={settingStyle.cardContainer}>
                <div className={settingStyle.widthPassStyle}>
                    <label className={settingStyle.labelStyle}>Current Password</label>
                    <div className={settingStyle.inputBox}>
                        <input type='text' onBlur={handleBlur} value={values.currentPassword} placeholder='Current Password' name="currentPassword" onChange={handleChange} />
                    </div>
                    {
                        errors.currentPassword && touched.currentPassword && <p style={{ color: "red", fontSize: "12px" }}>{errors.currentPassword}</p>
                    }
                </div>
                <div className={settingStyle.widthPassStyle}>
                    <label className={settingStyle.labelStyle}>New Password</label>
                    <div className={settingStyle.inputBox}>
                        <input type='text' onBlur={handleBlur} value={values.newPassword} placeholder='New Password' name="newPassword" onChange={handleChange} />
                    </div>
                    {
                        errors.newPassword && touched.newPassword && <p style={{ color: "red", fontSize: "12px" }}>{errors.newPassword}</p>
                    }
                </div>
                <div className={settingStyle.widthPassStyle}>
                    <label className={settingStyle.labelStyle}>Confirm Password</label>
                    <div className={settingStyle.inputBox}>
                        <input type='text' onBlur={handleBlur} value={values.confirmPassword} placeholder='Confirm Password' name="confirmPassword" onChange={handleChange} />
                    </div>
                    {
                        errors.confirmPassword && touched.confirmPassword && <p style={{ color: "red", fontSize: "12px" }}>{errors.confirmPassword}</p>
                    }
                </div>
            </div>
            <div className={settingStyle.changesPasswordButton} onClick={handleSubmit} style={{ minWidth: "175px", display: "flex", alignItems: "center", justifyContent: "center", opacity: isLoading ? 0.5 : 1 }}>
                {
                    isLoading ? <CircularProgress size={20} />
                        : <p>Change Password</p>
                }
            </div>
        </div>
    )
}

export default ChangePassword